import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getBalanceAndPin } from "../../features/balance-and-pin/balanceAndPinSlice";
import { getDasDeviceInfo } from "../../features/das-device-manager/dasDeviceManagerSlice";

import usePrevious from "../../hooks/usePrevious";
import PhotoMemoriesModal from "./PhotoMemoriesModal";
import Spinner from "../../components/Spinner";

import {
  MainContainer,
  NavBar,
  IntroContainer,
  DiscoverContainer,
  FooterContainer,
  ChargingInfoContainer,
  DiscoverItem,
  BalanceContainer,
} from "./styles";

import logo from "./imgs/nav-logos.svg";

import photo_memories_img from "./imgs/photo_memories.webp";
import live_mascot_experience_img from "./imgs/live_mascot_experience.webp";
import mastercard_shop_img from "./imgs/mastercard_shop.webp";
import half_time_refreshments_img from "./imgs/half_time_refreshments.webp";
import cloakroom_img from "./imgs/cloakroom.webp";
import discover_pricelessImg from "./imgs/discover_priceless.webp";

import poweredBy from "./imgs/digiseq-logo.svg";
import copyIconWhite from "./imgs/copy-icon-white.svg";
import paymeswissLogo from "./imgs/paymeswiss_logo.svg";

import packageJson from "../../../package.json";
import { usePromoTracking } from "../../hooks/usePromoTracking";
import { formattedBalance } from "../../features/balance-and-pin/utils";
import LiveMascotExperienceModal from "./LiveMoscotExperienceModal";
import MastercardShopModal from "./MastercardShopModal";
import HalfTimeRefreshmentsModal from "./HalfTimeRefreshmentsModal";
import DiscoverPricelessModal from "./DiscoverPricelessModal";
import CloakroomModal from "./CloakroomModal";
import Schedule from "./Schedule";

const SCHEDULE = [
  {
    id: "day-1",
    date: "2026-05-28",
    title: "Champions League Final",
    subtitle: null,
    agendaItems: [
      {
        id: "item-1",
        startTime: "15:00:00",
        endTime: null,
        startTimePrefix: "",
        title: "Champions Village Hospitality Opens",
        description: null,
      },
      {
        id: "item-2",
        startTime: "16:00:00",
        endTime: null,
        startTimePrefix: "",
        title: "Official Welcome",
        description: null,
      },
      {
        id: "item-3",
        startTime: "16:05:00",
        endTime: null,
        startTimePrefix: "",
        title: "Legends Q&A",
        description: null,
      },
      {
        id: "item-4",
        startTime: "17:20:00",
        endTime: null,
        startTimePrefix: "",
        title: "Guests to take their seats at the stadium",
        description: null,
      },
      {
        id: "item-5",
        startTime: "17:45:00",
        endTime: null,
        startTimePrefix: "",
        title: "Kick Off Show with the Killers",
        description: null,
      },
      {
        id: "item-6",
        startTime: "18:00:00",
        endTime: null,
        startTimePrefix: "",
        title: "Match Kick-off",
        description: null,
      },
      {
        id: "item-7",
        startTime: "19:45:00",
        endTime: null,
        startTimePrefix: "",
        title: "Final Whistle and Trophy Presentation",
        description:
          "The match end time may change in case of extra time and penalties",
      },
      {
        id: "item-8",
        endTime: null,
        startTimePrefix: "",
        title:
          "The match end time may change in case of extra time and penalties",
      },
      {
        id: "item-9",
        startTime: "23:00:00",
        endTime: null,
        startTimePrefix: "",
        title: "Hospitality area closes",
        description: "Champions Village closes 3 hours after final whistle",
      },
      {
        id: "item-10",
        endTime: null,
        startTimePrefix: "",
        title: "Champions Village closes 3 hours after final whistle",
      },
    ],
  },
];

const Uefa26Hospitality = () => {
  const [searchParams] = useSearchParams();
  const serialNumber = searchParams.get("serialNumber");

  const [copied, setCopied] = useState(false);
  const [isMounted, setIsMounted] = useState(false);

  const { trackButtonClick } = usePromoTracking("uefa", "UEFA 2026");

  const dispatch = useDispatch();
  const { balanceAndPin, isLoading } = useSelector(
    (state) => state.balanceAndPin,
  );

  useEffect(() => {
    setIsMounted(true);

    return () => {
      setIsMounted(false);
    };
  }, []);

  useEffect(() => {
    if (isMounted) {
      setTimeout(() => {
        setCopied(false);
      }, 2000);
    }
  }, [copied, isMounted]);

  useEffect(() => {
    if (!balanceAndPin && serialNumber) {
      dispatch(
        getBalanceAndPin({
          serial: serialNumber,
          query: "?provider=pannovate",
        }),
      );
    }
  }, [balanceAndPin, serialNumber, dispatch]);

  useEffect(() => {
    if (serialNumber) {
      dispatch(getDasDeviceInfo(serialNumber));
    }
  }, [serialNumber, dispatch]);

  const [isPhotoMemoriesOpen, setIsPhotoMemoriesOpen] = useState(false);
  const [isLiveMascotExperienceOpen, setIsLiveMascotExperienceOpen] =
    useState(false);
  const [isMastercardShopOpen, setIsMastercardShopOpen] = useState(false);
  const [isHalfTimeRefreshmentsOpen, setIsHalfTimeRefreshmentsOpen] =
    useState(false);
  const [isCloakroomOpen, setIsCloakroomOpen] = useState(false);
  const [isDiscoverPricelessOpen, setIsDiscoverPricelessOpen] = useState(false);

  const handleClose = (closeItem) => {
    const discoverContainer = document.getElementById("discover");
    discoverContainer.scrollIntoView({ behavior: "smooth" });

    switch (closeItem) {
      case "photomemories":
        setIsPhotoMemoriesOpen(false);
        break;
      case "liveMascotExperience":
        setIsLiveMascotExperienceOpen(false);
        break;
      case "mastercardShop":
        setIsMastercardShopOpen(false);
        break;
      case "halfTimeRefreshments":
        setIsHalfTimeRefreshmentsOpen(false);
        break;
      case "cloakroom":
        setIsCloakroomOpen(false);
        break;
      case "discoverPriceless":
        setIsDiscoverPricelessOpen(false);
        break;
      default:
        break;
    }
  };

  const handleOpen = (openItem) => {
    window.scrollTo(0, 0);
    switch (openItem) {
      case "photomemories":
        setIsPhotoMemoriesOpen(true);
        break;
      case "liveMascotExperience":
        setIsLiveMascotExperienceOpen(true);
        break;
      case "mastercardShop":
        setIsMastercardShopOpen(true);
        break;
      case "halfTimeRefreshments":
        setIsHalfTimeRefreshmentsOpen(true);
        break;
      case "cloakroom":
        setIsCloakroomOpen(true);
        break;
      case "discoverPriceless":
        setIsDiscoverPricelessOpen(true);
        break;
      default:
        break;
    }
  };

  if (isLoading) return <Spinner />;

  return (
    <MainContainer>
      <NavBar>
        <img src={logo} alt="logo" />
      </NavBar>
      <IntroContainer>
        <div className="image-container"></div>

        <div className="text-container">
          <h2>{"Welcome!"}</h2>
          <p>
            We are delighted to welcome you to the UEFA Champions League Final,
            one of the most prestigious events in European football. Bringing
            together the best club teams from across the continent to compete
            for the coveted trophy during the final match in Budapest.
          </p>
        </div>
      </IntroContainer>

      <BalanceContainer>
        <div className="image-container">
          <h2>
            Balance:{" "}
            {balanceAndPin?.balanceDetails?.availableBalance
              ? formattedBalance(
                  balanceAndPin?.balanceDetails?.availableBalance,
                  balanceAndPin?.balanceDetails?.currency,
                  true,
                )
              : "N/A"}
          </h2>
        </div>
      </BalanceContainer>
      <ChargingInfoContainer>
        <p>
          {
            "Charging cables are available to borrow at the welcome desk to charge your phone in the lounge."
          }
        </p>
      </ChargingInfoContainer>
      <DiscoverContainer id="discover">
        <h2>{"Matchday Experiences"}</h2>
        <p>{"Tap to discover what’s happening around the Final today"}</p>
        <div className="items-container">
          <DiscoverItem
            onClick={() => {
              trackButtonClick("photomemories");
              handleOpen("photomemories");
            }}
          >
            <img src={photo_memories_img} alt="photomemories" />
          </DiscoverItem>
          <DiscoverItem onClick={() => handleOpen("liveMascotExperience")}>
            <img
              src={live_mascot_experience_img}
              alt="live mascot experience"
            />
          </DiscoverItem>
          <DiscoverItem onClick={() => handleOpen("mastercardShop")}>
            <img src={mastercard_shop_img} alt="mastercard shop" />
          </DiscoverItem>
          <DiscoverItem onClick={() => handleOpen("halfTimeRefreshments")}>
            <img
              src={half_time_refreshments_img}
              alt="half time refreshments"
            />
          </DiscoverItem>
          <DiscoverItem onClick={() => handleOpen("cloakroom")}>
            <img src={cloakroom_img} alt="cloakroom" />
          </DiscoverItem>
          <DiscoverItem onClick={() => handleOpen("discoverPriceless")}>
            <img src={discover_pricelessImg} alt="discover priceless" />
          </DiscoverItem>
        </div>
      </DiscoverContainer>
      <Schedule days={SCHEDULE} error={""} />
      <FooterContainer>
        <h3>{"Powered by"}</h3>
        <img src={poweredBy} alt="powered by" />
        <h3>{"Payment services by"}</h3>
        <img src={paymeswissLogo} alt="payment services" />
        <br />
        {serialNumber && (
          <div className="copyToClipboard">
            <p>ID: {serialNumber}</p>
            <img
              onClick={() => {
                navigator.clipboard.writeText(serialNumber);
                setCopied(true);
              }}
              src={copyIconWhite}
              alt="copy to clipboard"
            />
          </div>
        )}
        <div className="version">
          <p>v.{packageJson.version}</p>
        </div>
        {copied && (
          <p>
            <b>Copied to clipboard</b>
          </p>
        )}
      </FooterContainer>
      {isPhotoMemoriesOpen && (
        <PhotoMemoriesModal
          serialNumber={serialNumber}
          onClose={() => handleClose("photomemories")}
        />
      )}
      {isLiveMascotExperienceOpen && (
        <LiveMascotExperienceModal
          onClose={() => handleClose("liveMascotExperience")}
        />
      )}
      {isMastercardShopOpen && (
        <MastercardShopModal
          serialNumber={serialNumber}
          onClose={() => handleClose("mastercardShop")}
        />
      )}
      {isHalfTimeRefreshmentsOpen && (
        <HalfTimeRefreshmentsModal
          serialNumber={serialNumber}
          onClose={() => handleClose("halfTimeRefreshments")}
        />
      )}
      {isCloakroomOpen && (
        <CloakroomModal
          serialNumber={serialNumber}
          onClose={() => handleClose("cloakroom")}
        />
      )}
      {isDiscoverPricelessOpen && (
        <DiscoverPricelessModal
          serialNumber={serialNumber}
          onClose={() => handleClose("discoverPriceless")}
        />
      )}
    </MainContainer>
  );
};

export default Uefa26Hospitality;
